import React from 'react'
import './style.css'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PlanSubscribeBanner = () => {
  const apps = useSelector(state => state.apps)
  const history = useHistory()

  const handleRedirect = () => {
    history.push(`/app/${apps.active.id}/plans-billing`)
  }

  return (
    <div className="header-subscribe-banner">
      <div className="header-banner__text">
        Your plan has expired, please subscribe to a plan to continue using the app.
      </div>
      <div className="header-banner__button-container">
        <button type="button" className="header-banner__upgrade-button" onClick={handleRedirect}>
          Subscribe Now
        </button>
      </div>
    </div>
  )
}

export default PlanSubscribeBanner
